import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiObjectEditorInfoComponent } from './fi-object-editor-info.component';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { MatCardModule } from '@angular/material/card';

@NgModule({
    imports: [CommonModule, FiProfileIconModule, FiAppTextSharedModule, MatCardModule],
    declarations: [FiObjectEditorInfoComponent],
    exports: [FiObjectEditorInfoComponent],
})
export class FiObjectEditorInfoModule {}
